<template>
    <div class="carlist_wrapper">
        <!--品牌-->
        <div class="series_wrapper" v-if="series_show">
            <div class="header_wrapper">
                <b class="left_title">选择品牌</b>
            </div>
            <div class="out_main_wrapper">
                <div class="main_wrapper_series custom_car">
                    <div class="left_firstseries" ref="left_firstseries">
                        <van-field v-model="search_brand" placeholder="请输入品牌" @input="onSearch"
                            class="search_ipt">
                            <van-button v-if="!isShowSearch" slot="button" size="small">
                                搜索
                            </van-button>
                            <van-button v-if="isShowSearch" slot="button" size="small" @click="cancelSearch">
                                取消
                            </van-button>
                        </van-field>
                        <!--列表-->
                        <div class="series_list_wrapper" @scroll="handleScroll()" ref="series_list_wrapper">
                            <ul class="series_list">
                                <li class="series_list_item" v-for="(brand, idx) in brand" :key="idx"
                                    @click="clk_brand(brand)">
                                    {{ brand }}
                                </li>
                            </ul>

                            <!-- 空白提示 -->
                            <div class="series_list_empty" v-if="brand.length == 0">
                                <img src="../assets/image/empty.png" alt="空白提示">
                                <p>暂无品牌</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--车型-->
        <div class="brand_wrapper" v-if="brand_show">
            <div class="header_wrapper">
                <van-icon name="arrow-left" @click="goback" />
                <b class="left_title">{{ brand_name }}</b>
                <van-icon name="cross" @click="closePopup" />
            </div>
            <div class="main_wrapper_brand">
                <ul>
                    <!--  brand_list-->
                    <li class="series_list_item" v-for="(series, series_id) in series_list" :key="series_id"
                        @click="clk_series(series)">
                        {{ series }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import lib_requirement from "@/libs/lib_requirement";

export default {
    props: {
        activity_id: { type: Number, default: 0 }, //项目id
        custom_car: { type: Number, default: 0 }, //是否自定义车型库
        is_dialog_car: { type: Boolean, default: false },
        city: { type: String, default: '' },
        brand_list: { type: Array, default: [] }
    },

    data() {
        return {
            hot: [], //热门车型
            brand: [], //品牌
            letter: [], //右侧ABC
            series_list: [], //车型
            brand_id: undefined, //品牌id
            brand_name: '', //品牌name
            require_id: '',
            search_brand: '',


            is_brand: true,
            current_brand: {},

            series_show: true,
            brand_show: false,
            overflow_flag: false,
            isShowSearch: false,
        };
    },
    created() {
        this.brand = this.brand_list;
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {

        onSearch() {
            let that = this;
            if (that.search_brand.trim() != '') {
                this.isShowSearch = true;
                that.brand = that.brand_list.filter(item => {
                    return item.includes(that.search_brand)
                })
            } else {
                this.search_brand = '';
                this.isShowSearch = false;
                this.brand = this.brand_list;
            }
        },
        cancelSearch() {
            this.search_brand = '';
            this.isShowSearch = false;
            this.brand = this.brand_list;
        },

        //选择品牌
        clk_brand(brand) {
            //先清空车型列表
            this.series_list = []
            this.brand_name = brand;  // 品牌name
            this.series_show = false;
            this.brand_show = true;
            let that = this;
            lib_requirement.atbseries(this.city, brand, function (data) {
                that.series_list = data.series_list
                that.require_id = data.require_id
            })


        },

        //选择车型
        clk_series(series_name) {
            // this.is_brand = true;
            this.series_show = false;
            this.brand_show = false;
            this.$emit("query", this.brand_name, series_name, this.require_id);
        },

        // others methods
        closePopup() {
            this.$emit('handleClose', false)
        },
        goback() {
            // this.is_brand = true;
            this.brand_show = false;
            this.series_show = true;
            this.brand_name = '';
            this.series_list = []
        },

    },
    watch: {
        is_dialog_car(v) {
            this.series_show = v;
            this.brand = this.brand_list;
            this.brand_show = false;
            this.brand_name = '';
            this.series_list = []
            this.search_brand = ''
        },
        series_show(v) {
            if (v == true) {

                // this.activeLetter = this.letter[0]
            }
        },
    },

};
</script>

<style lang="less">
@import "../assets/style/carList/carlist_noimg.less";

.custom_car {
    width: calc(100% - 50px);
    margin: 0 24px;

    .van-cell::after {
        border: none;
    }
}

.search_ipt {
    padding: 8px 8px 8px 24px;
    margin: 0 0 20px 0;
    border-radius: 10px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
}

.van-button--default {
    border: none;
    font-size: 28px;
}

.series_list_empty {
    text-align: center;
    font-size: 28px;
    color: #89939F;

    img {
        width: 260px;
        height: auto;
        margin-top: 150px;
        margin-bottom: 20px;
    }
}
</style>
